import filter1 from './filter1.js';
import filter2 from './filter2.js';
import filter3 from './filter3.js';
import filter4 from './filter4.js';
import filter5 from './filter5.js';
import filter6 from './filter6.js';
import filter7 from './filter7.js';
import filter8 from './filter8.js';
import filter9 from './filter9.js';
import filter10 from './filter10.js';

export default {
  'Lunettes': filter1,
  'Moustache': filter2,
  'Chapeau': filter3,
  'Lèvres': filter4,
  'Étoiles': filter5,
  'PixelFace': filter6,
  'Couronne': filter7,
  'Cœur': filter8,
  'Casquette': filter9,
  'Masque': filter10
};
